export default __webpack_public_path__ + "static/media/influence.377b8bee.png";